import React from "react";

const MultiLine: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ children }) => {
  return <p style={{ whiteSpace: "pre-line" }}>{children}</p>;
};

export default MultiLine;
